import React from 'react';
import { contact } from '../../data/site';
import { nextSteps } from '../../data/process';
import { Reveal } from '../ui/Reveal';
const takeaways = ['All-in-One Power System: initial setup 3–4 hours, about 30 minutes after that', 'Plug-and-play once the initial setup is done', 'Durable components selected for Australian conditions', 'Systems tested in remote areas', 'Based in Perth, deploying Australia-wide'];
const services = ['All-in-One containerised power systems', 'Hybrid diesel replacement', 'Utility-scale energy storage', 'System design, integration and commissioning', 'Ongoing support'];
export function InShort() {
  return <section aria-labelledby="in-short-title" className="bg-afb-light" data-id="element-385" data-mp="27cuhk445vq1s">
      <div className="mx-auto grid max-w-page gap-12 px-5 py-20 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16 lg:px-8 lg:py-24" data-id="element-386" data-mp="22hxdlblqo6vr">
        <Reveal data-id="element-387" data-mp="1ygbrcznbeg8w">
          <h2 id="in-short-title" className="font-sora text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] md:text-[2.75rem]" data-id="element-388" data-mp="1tfo48p27ijjy">
            What Australian Flow Batteries does
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-afb-ink/85" data-id="element-389" data-mp="mfo06onv6kvn">
            Australian Flow Batteries (AFB) provides containerised power systems for remote, off-grid and critical
            sites across Australia. Each system combines solar generation and energy storage in a transportable
            container that’s fast to deploy and simple to operate. AFB supports diesel displacement, microgrids and
            resilient backup power from its base in Bibra Lake, Perth.
          </p>

          <h3 className="mt-10 font-sora text-lg font-semibold" data-id="element-390" data-mp="rfaopu957njr">Key takeaways</h3>
          <ul className="mt-4 space-y-3" data-id="element-391" data-mp="rhdb84b36yjq">
            {takeaways.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-afb-ink/85" data-id="element-392" data-mp="wg8644mbwdk7">
                <span className="mt-[9px] h-1.5 w-1.5 shrink-0 rounded-full bg-afb-teal" aria-hidden="true" data-id="element-393" data-mp="3c3yhl7ral2fy" />
                {item}
              </li>)}
          </ul>

          <div className="mt-8 border-l-2 border-afb-turquoise pl-5" data-id="element-394" data-mp="1mnme6qwmx717">
            <p className="text-[15px] leading-relaxed text-afb-ink/85" data-id="element-395" data-mp="1horkgtx4py2b">
              <strong className="font-semibold text-afb-ink" data-id="element-396" data-mp="1cyb7fax80egh">When to choose AFB:</strong> you need dependable power
              where the grid is missing, weak or at risk, and you need it set up quickly and kept simple to run.
            </p>
          </div>
        </Reveal>

        <Reveal delay={60} data-id="element-397" data-mp="13vjsh154z0k3">
          <div className="rounded-card border border-afb-line bg-white p-6 md:p-8" data-id="element-398" data-mp="yytf4lkpuj2d">
            <h3 className="font-sora text-lg font-semibold" data-id="element-399" data-mp="z0wbdncgp8fj">Fact sheet</h3>
            <dl className="mt-6 divide-y divide-afb-line text-[15px]" data-id="element-400" data-mp="tzqinpisxl60">
              <div className="pb-5" data-id="element-401" data-mp="pywvwzh3icep">
                <dt className="font-medium text-afb-ink" data-id="element-402" data-mp="pzyahdxblh16">Services offered</dt>
                <dd className="mt-2" data-id="element-403" data-mp="2ocy8f2rx76ks">
                  <ul className="space-y-1.5 text-afb-muted" data-id="element-404" data-mp="2kbwgz848vytd">
                    {services.map(service => <li key={service} data-id="element-405" data-mp="64n6fan1aq9a">{service}</li>)}
                  </ul>
                </dd>
              </div>
              <div className="py-5" data-id="element-406" data-mp="b1x1b5t6zu4i">
                <dt className="font-medium text-afb-ink" data-id="element-407" data-mp="b0vhabu77xan">Areas served</dt>
                <dd className="mt-2 text-afb-muted" data-id="element-408" data-mp="fuq8e0c4vejr">Australia-wide, from our base in Bibra Lake, Perth (WA)</dd>
              </div>
              <div className="py-5" data-id="element-409" data-mp="3janadm055g70">
                <dt className="font-medium text-afb-ink" data-id="element-410" data-mp="3jboyar299x65">What happens next</dt>
                <dd className="mt-2" data-id="element-411" data-mp="3o9891gzqvrtc">
                  <ol className="space-y-1.5 text-afb-muted" data-id="element-412" data-mp="3oa9xcn5ruat0">
                    {nextSteps.map((step, index) => <li key={step.title} data-id="element-413" data-mp="3sdg19o5evpwb" data-mpi={index}>
                        {index + 1}. {step.title}
                      </li>)}
                  </ol>
                </dd>
              </div>
              <div className="py-5" data-id="element-414" data-mp="17n7804e9nxuc">
                <dt className="font-medium text-afb-ink" data-id="element-415" data-mp="1cjo1zf85d6fc">Response time</dt>
                <dd className="mt-2 text-afb-muted" data-id="element-416" data-mp="1b30kd06sju66">Within 48 hours</dd>
              </div>
              <div className="pt-5" data-id="element-417" data-mp="1b4v5aei2bma9">
                <dt className="font-medium text-afb-ink" data-id="element-418" data-mp="164qpkqozavl3">Contact options</dt>
                <dd className="mt-2 flex flex-col gap-1.5" data-id="element-419" data-mp="1k3glw43z4r8e">
                  <a href={contact.phoneHref} className="font-medium text-afb-teal underline-offset-4 hover:underline" data-id="element-420" data-mp="1k51hlx20yg7u">
                    Call {contact.phoneDisplay}
                  </a>
                  <a href={contact.emailHref} className="font-medium text-afb-teal underline-offset-4 hover:underline" data-id="element-421" data-mp="1u0bjmksfanlm">
                    Email {contact.email}
                  </a>
                  <a href="#contact" className="font-medium text-afb-teal underline-offset-4 hover:underline" data-id="element-422" data-mp="23qe8q9wfbheo">
                    Request a demo / site assessment
                  </a>
                </dd>
              </div>
            </dl>
          </div>
        </Reveal>
      </div>
    </section>;
}